// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"532":"styles","2143":"app"}[chunkId] || chunkId) + "." + {"532":"1e0d3654e0ceb178ec31","2143":"ddb636185a537012e9c1","3485":"92a1cd23157ffabd8515"}[chunkId] + ".css";
};